import { translate } from "../../utils/localization"

class LoadingBar {
  constructor(scene) {
    this.scene = scene
    this.value = 0
    this.progressBar = null
    this.progressBox = null
    this.loadingText = null
    this.percentText = null
    this.draw()
  }

  setValue(val) {
    this.value = val
    this.updateProgress()
    if(this.value >= 1) {
      this.unload()
    }
  }

  updateProgress() {
    const screenCenterX = this.scene?.cameras?.main?.worldView.x + this.scene?.cameras?.main?.width / 2;
    const screenCenterY = this.scene?.cameras?.main?.worldView.y + this.scene?.cameras?.main?.height / 2;
    this.percentText.setText(parseInt(this.value * 100) + '%');
    this.progressBar.clear();
    this.progressBar.fillStyle(0xffffff, 1);
    this.progressBar.fillRect(screenCenterX-300/2, screenCenterY-30/2, 300 * this.value, 30);
  }

  draw() {
    this.progressBar = this.scene.add.graphics();
    this.progressBox = this.scene.add.graphics();
    this.progressBox.fillStyle(0x222222, 0.8);
    const screenCenterX = this.scene?.cameras?.main?.worldView.x + this.scene?.cameras?.main?.width / 2;
    const screenCenterY = this.scene?.cameras?.main?.worldView.y + this.scene?.cameras?.main?.height / 2;
    const width = this.scene.cameras.main.width;
    const height = this.scene.cameras.main.height;

    this.progressBox.fillRect(screenCenterX-320/2, screenCenterY-50/2, 320, 50);
    
    this.loadingText = this.scene.make.text({
        x: width / 2,
        y: height / 2 - 50,
        text: translate('menu.main.loading_message'),
        style: {
            font: '20px monospace',
            fill: '#ffffff'
        }
    });
    this.loadingText.setOrigin(0.5, 0.5);
    
    this.percentText = this.scene.make.text({
        x: width / 2,
        y: screenCenterY + 50,
        text: '0%',
        style: {
            font: '18px monospace',
            fill: '#ffffff'
        }
    });
    this.percentText.setOrigin(0.5, 0.5);
  }

  unload() {
    this.progressBar.destroy();
    this.progressBox.destroy();
    this.loadingText.destroy();
    this.percentText.destroy();
  }
}

export default LoadingBar;
